import { useEffect, useState, useCallback, useMemo } from 'react'
import CoreEnums from '../../../../core/utils/enums'
import { uniqBy } from 'lodash'

import { useDispatch, useSelector } from 'react-redux'
import coreReducer from '../../../../core/utils/reducer'

const useClinicsList = ({ data = [], createRecord }) => {
  const coreState = useSelector((state) => state.core)
  const dispatch = useDispatch()

  // Memoize filters to avoid unnecessary re-renders
  const [filters, setFilters] = useState({
    province: [],
    clinicType: [],
    name: [],
    address: []
  })

  // Memoize province filters to avoid recreation on every render
  const provinceFilters = useMemo(() => {
    return Object.values(CoreEnums.provinces).map((province) => ({
      text: province,
      value: province
    }))
  }, [])

  // Memoize clinic type filters from data
  const clinicTypeFilters = useMemo(() => {
    return uniqBy(
      data
        .filter((item) => item.clinicType)
        .map((item) => ({
          text: item.clinicType,
          value: item.clinicType
        })),
      'text'
    )
  }, [data])

  // Update filters when data changes
  useEffect(() => {
    setFilters((prevFilters) => ({
      ...prevFilters,
      province: provinceFilters,
      clinicType: clinicTypeFilters
    }))
  }, [provinceFilters, clinicTypeFilters])

  // Handle create button click with tour support
  const handleCreateClick = useCallback(() => {
    if (coreState.tourOpen) {
      dispatch(coreReducer.actions.nextTourStep())
    }
    createRecord()
  }, [coreState.tourOpen, createRecord, dispatch])

  return {
    filters,
    coreState,
    handleCreateClick
  }
}

export default useClinicsList
